import OrderIcon from '@mui/icons-material/AttachMoney';

import OrderList from './OrderList';
import OrderEdit from './OrderEdit';

export default {
    list: OrderList,
    edit: OrderEdit,
    icon: OrderIcon,
    recordRepresentation: 'reference',
};
